// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"TabSectionA_TheComp__o_5WC"};